import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, TitleWrapper, MenuButton, LogoTitle } from './wrappers.ts';
import { colors } from '../../assets/colors/index.tsx';
import { getToken } from '../../utils/authHelpers.ts';

export const TemporaryDrawer = () => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = React.useState(() => getToken());

  React.useEffect(() => {
    setToken(getToken());
  }, [location]);

  const menuItems = [
    { text: 'Find',              path: '/' },
    { text: 'About',             path: '/about' },
    { text: 'Q&A',               path: '/questions-and-answers' },
    { text: 'List your coliving', path: '/sign-up?role=owner' },
    { text: token ? 'Profile' : 'Log in', path: token ? '/profile' : '/login' },
  ];

  const handleNav = (path: string) => {
    navigate(path);
    setOpen(false);
  };

  return (
    <Container>
      <TitleWrapper>
        <MenuButton onClick={() => setOpen(true)} aria-label="Open menu">
          <MenuRoundedIcon style={{ color: colors.quaternary, fontSize: '1.4rem' }} />
        </MenuButton>
        <LogoTitle onClick={() => handleNav('/')}>The Colivings</LogoTitle>
      </TitleWrapper>

      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: 260,
            border: 'none',
          },
        }}
      >
        <div style={{ padding: '1.25rem 1rem 0.75rem', borderBottom: `1px solid #f0ebe7` }}>
          <LogoTitle style={{ fontSize: '1rem' }}>The Colivings</LogoTitle>
        </div>

        <List sx={{ pt: 1 }}>
          {menuItems.map(({ text, path }) => (
            <ListItem key={text} disablePadding>
              <ListItemButton
                onClick={() => handleNav(path)}
                sx={{
                  px: 2,
                  py: 1,
                  '&:hover': { background: colors.quinary },
                }}
              >
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    color: colors.quaternary,
                  }}
                />
                {(text === 'Log in' || text === 'Profile') && (
                  <PersonIcon style={{ fontSize: '1rem', color: colors.tertiary }} />
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Container>
  );
};
